import { IContextInitial } from "../model/ContextModal";
import { CountryEnum, Employee, isAccessible, UserEnum } from "../utils/app-common";
import { useUserContextHook } from "./useUserContextHook";

const useAuthorizationHook = () => {
  const { employeeDetail }: IContextInitial = useUserContextHook();
  const { positionId } = employeeDetail ?? {};

  const isFinanceUser = [
    UserEnum.FINANCE,
    UserEnum.FINANCE_CONTROLLER,
  ].includes(positionId!);
  const isFinanceUserController = [UserEnum.FINANCE_CONTROLLER].includes(
    positionId!
  );
  const isDataAnalystUser = [UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,].includes(positionId!);
  const isManagerUser = [UserEnum.MANAGER].includes(positionId!);
  const isFleetSupervisor = [UserEnum.FLEET_SUPERVISOR].includes(positionId!);
  const isCustomerService = [UserEnum.CUSTOMER_SERVICE].includes(positionId!);
  const isGatewayUser = [UserEnum.GATEWAY_USER].includes(positionId!);
  const isITSupportUser = [UserEnum.IT_SUPPORT].includes(positionId!);
  const isOperationSupervisor = [UserEnum.OPERATION_SUPERVISOR].includes(
    positionId!
  );
  const isLegalUser = [UserEnum.LEGAL_USER].includes(positionId!);
  const isOperationCSSupervisor = [UserEnum.OPERATION_CS_SUPERVISOR, UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,].includes(
    positionId!
  );
  const isOperationStaff = [UserEnum.OPERATION_STAFF].includes(positionId!);
  const isBanderAllafi = isAccessible(
    [Employee.BANDER_ALLAFI, Employee.NOHA_KARKADAN],
    [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
    true
  );
  const isOperatorCashCollector = isBanderAllafi || [UserEnum.OPERATOR_CASH_COLLECTOR].includes(
    positionId!
  );
  const isManifestor = [UserEnum.MANIFESTER, UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,].includes(positionId!);
  const isOperationSupervisorAndCashCollector = [
    UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
  ].includes(positionId!);
  const isCSVUser = [UserEnum.CSV].includes(positionId!);
  const isDataLogger = [UserEnum.DATA_LOGGER].includes(positionId!);
  const isPricingTeam = [UserEnum.QUOTATION].includes(positionId!);
  const isOperationSupervisorAndOperationStaff = [
    UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
  ].includes(positionId!);

  return {
    isManifestor,
    isFinanceUser,
    isDataAnalystUser,
    isManagerUser,
    isFleetSupervisor,
    isCustomerService,
    isOperationSupervisor,
    isOperationCSSupervisor,
    isOperationStaff,
    isOperatorCashCollector,
    isOperationSupervisorAndCashCollector,
    isCSVUser,
    isFinanceUserController,
    isDataLogger,
    isPricingTeam,
    isOperationSupervisorAndOperationStaff,
    isLegalUser,
    isGatewayUser,
    isITSupportUser
  };
};

export default useAuthorizationHook;
